import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { from, of } from 'rxjs';
import { mergeMap, reduce } from 'rxjs/operators';

type TitlePartType = (string|{title: string, slug?: string});

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly title: Title,
    private readonly translate: TranslateService) {
  }

  public updatePageTitleFromRoute(): void {
    let route = this.activatedRoute;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const routeData = route.snapshot.data;
    if (routeData['title']) {
      this.setTitle([{ title: routeData['title'] }]);
    }
  }

  public setTitle(titleParts: TitlePartType[], separator = ' '): void {
    from(titleParts).pipe(
      mergeMap((titlePart: TitlePartType) => (
        typeof titlePart === 'string'
          ? of(titlePart)
          : this.translate.get(titlePart.title, { slug: titlePart.slug || '' })
      )),
      reduce((titleString, titlePart) => titleString + separator + titlePart, '')
    ).subscribe((titleString: string) => {
      this.title.setTitle(titleString);
    });
  }
}
